import React, { PureComponent, Fragment } from 'react';
import { Metric, Error } from './../../Utils/Utils.js';
import Heading from '../../Elements/Heading';


class MinutesWatchedYesterdayDreamworks extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />
    }

    return (

      <Fragment>
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Heading size={6} className={'mb-1'} icons={data.minutes.two_days_ago.networks} icons_size={'sm'}>
              Minutes Watched 2 Days Ago
            </Heading>
            <Metric {...data.minutes.two_days_ago} size={'lg'} />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-4">
            <Heading size={6} className={'mb-1'}>
              Last 7 Days
            </Heading>
            <Metric value={data.minutes.last7} size={'md'} />
          </div>
          <div className="col-4">
            <Heading size={6} className={'mb-1'}>
              Last 30 Days
            </Heading>
            <Metric value={data.minutes.last30} size={'md'} />
          </div>
          <div className="col-4">
            <Heading size={6} className={'mb-1'}>
              Year-To-Date
            </Heading>
            <Metric value={data.minutes.ytd} size={'md'} />
          </div>
        </div>
      </Fragment>

    );
  }
}

export default MinutesWatchedYesterdayDreamworks
